import { render, staticRenderFns } from "./AppointmentsDeletedChart.vue?vue&type=template&id=a465cb4a&"
import script from "./AppointmentsDeletedChart.vue?vue&type=script&lang=js&"
export * from "./AppointmentsDeletedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports